import { AccessErrorReason } from '../actions/access-error-state.action';

export interface IAccessErrorLabels {
    accessErrorNotSignedInText?: string;
    accessErrorNoSuiteAccessText?: string;
    accessErrorNoCustomerAccountText?: string;
    accessErrorEventNotAvailableText?: string;
    accessErrorSuiteNotConfiguredText?: string;
    accessErrorServiceUnavailableText?: string;
    accessErrorSessionExpiredText?: string;
}

/**
 * What the guest is told when no label has been authored. Most of these are not refusals: an event that is
 * not on offer, a suite with no store behind it and a check that could not be completed each have their own
 * wording, because telling all three that they have no access sends them to the wrong person for help.
 */
const ACCESS_ERROR_FALLBACKS: Record<AccessErrorReason, string> = {
    'not-signed-in': 'Something went wrong. Please try again.',
    'no-suite-access': "You don't have access to order for this suite.",
    'no-customer-account': "We couldn't find an account for you. Please contact us at premiumanswersportal@intuitdome.com",
    'event-not-available': "Ordering isn't available for this event.",
    'suite-not-configured': "This suite isn't set up for ordering yet. Please contact us at premiumanswersportal@intuitdome.com",
    'service-unavailable': "We couldn't check your access right now. Please try again in a moment.",
    'session-expired': 'Something went wrong. Please reopen the menu and try again.'
};

/** The labels the header was authored with, for messages raised outside it. */
let rememberedLabels: IAccessErrorLabels = {};

export const rememberAccessErrorLabels = (labels: IAccessErrorLabels): void => {
    rememberedLabels = labels;
};

export const accessErrorMessage = (reason: AccessErrorReason, labels: IAccessErrorLabels = rememberedLabels): string => {
    const authored: Partial<Record<AccessErrorReason, string | undefined>> = {
        'not-signed-in': labels.accessErrorNotSignedInText,
        'no-suite-access': labels.accessErrorNoSuiteAccessText,
        'no-customer-account': labels.accessErrorNoCustomerAccountText,
        'event-not-available': labels.accessErrorEventNotAvailableText,
        'suite-not-configured': labels.accessErrorSuiteNotConfiguredText,
        'service-unavailable': labels.accessErrorServiceUnavailableText,
        'session-expired': labels.accessErrorSessionExpiredText
    };

    return authored[reason]?.trim() || ACCESS_ERROR_FALLBACKS[reason];
};
